<template>
    <div>
        <BaseDatatable :module="`menu`" :apiurl="url" :fields="fields"></BaseDatatable>
    </div>
</template>

<script>
import BaseDatatable from '../../core/BaseDatatable'

export default {
  name: 'MenuList',
  props: ['url'],
  components: {BaseDatatable},
  data () {
    return {
      apiurl: this.url,
      fields: [
        {
          name: 'name',
          sortField: 'name',
          title: this.$translate.t('Name')
        },
        {
          name: '__slot:actions',
          title: this.$translate.t('Actions')
        }
      ],
      roles: {},
      page: 1,
      filters: {}
    }
  },
  created: function () {
    this.$emit('updateTitle', 'Menu ' + this.$translate.t('List'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/menu/MenuList.vue